import React, { useEffect, useState } from 'react'
import {findUserData, updateUserData2 } from '../../controllers/user.controller'
import profileImage from "../../media/profilePicture.png"
import {toast} from "react-hot-toast";

  //TODO make a dasboard explaining about the app
  //TODO design  loggin system
  //TODO make a discount system
  //TODO biblioteca section I can watch how muchs books you take
  //TODO apuntes I can upload and download classnotes 


function UserCard({userData}) {

  const [mood, setMood] = useState(0)
  const [userDataFields, setUserDataFields]=useState({name:"", lastName:"", email:"",DNI:"", phone:"",address:"",course:"",legajo:"", year:"", success:""})
  const [userInfoFromDataBase, setUserInfo]=useState({name:"", lastName:"", email:"",DNI:"", phone:"",address:"",course:"",legajo:"", year:"", success:""})



  //!recibe la data del usuario
  useEffect(() => {
    //console.log("Este es el usuario " + userData)
    readDataUser(userData)

  }, [])

  function readDataUser(name) {
    findUserData(name).then(
      data => setUserInfo(data[0])
      
    ).catch(
      e => toast.error("Error cargando datos de usuario")
    )
  }
  

  //!cambia entre modo de edicion y de lectura
  function selectMood(){
    if(mood===0){
      setMood(1)
    }else{
      setMood(0)
      updateUserData2(
        userData,
        userInfoFromDataBase.name,
        userInfoFromDataBase.lastName,
        userInfoFromDataBase.email,
        userInfoFromDataBase.DNI, 
        userInfoFromDataBase.phone,
        userInfoFromDataBase.address,
        userInfoFromDataBase.course,
        userInfoFromDataBase.legajo, 
        userInfoFromDataBase.year, 
        userInfoFromDataBase.success
       )
       readDataUser(userData)
    }
  }

   //!DATE HANDLE
   function dateHanddler(bookDate) {
      const dateParts = bookDate.split('/');
      const date = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
      const currentDate = new Date();
    
      const timeDifference = currentDate.getTime() - date.getTime();
      const daysDifference = timeDifference / (1000 * 3600 * 24);

      

      if (daysDifference > 15) {
        return "suspendido";
      
      } else {
        const round = Math.floor(daysDifference);
        return round;
      }
   }

   const getLabelClass = (labelText) => {
    if (labelText === "suspendido") {
      return "bg-danger rounded-1 col-3 text-white";
    } else if (labelText <= 3) {
      return "bg-warning rounded-1 col-3 text-white";
    } else {
      return "bg-success rounded-1 col-3 text-white";
    }
  };
   

  return (
    <div className="bg-white p-3">
        <div className="creamBackground rounded-5 m-2 px-2 py-4 text-center">
          {userInfoFromDataBase.email !== ""? 

          <div className="d-flex flex-column align-items-center justify-content-center">
              <img src={profileImage} alt="profileImage" width="200px" className="rounded-circle" />
              {mood===0 && <h1 className="regularText military fw-bold mt-3">{userInfoFromDataBase.name !== ""? `${userInfoFromDataBase.name} ${userInfoFromDataBase.lastName}`:"Cargando"}</h1>}
          </div>
          :
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div class="spinner-grow text-success" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          }

          
          {mood===0 &&
          <div className="d-flex flex-row flex-wrap py-5 px-3">

          <div className="d-flex flex-column align-items-center gap-3 col-12 col-md-6">

                <span className="d-flex flex-row gap-2">
                  <label className="fw-bold text-dark fs-3">Correo:</label>
                  <label className="fs-3">{userInfoFromDataBase.email !== ""? userInfoFromDataBase.email:"example@mail.com"}</label>
                </span>

                <span className="d-flex flex-row gap-2">
                  <label className="fw-bold text-dark fs-3">DNI:</label>
                  <label className="fs-3">{userInfoFromDataBase.DNI !== ""? userInfoFromDataBase.DNI:"00.000.000"}</label>
                </span>

                <span className="d-flex flex-row gap-2">
                  <label className="fw-bold text-dark fs-3">Celular:</label>
                  <label className="fs-3">{userInfoFromDataBase.phone !== ""? userInfoFromDataBase.phone:"385-000-0000"}</label>
                </span>

                <span className="d-flex flex-row gap-2">
                  <label className="fw-bold text-dark fs-3">Residencia:</label>
                  <label className="fs-3">{userInfoFromDataBase.address !== ""? userInfoFromDataBase.address:"cargando"}</label>
                </span>

          </div>

          <div className="d-flex flex-column align-items-center gap-3 col-12 col-md-6">

             <span className="d-flex flex-row gap-2">
                <label className="fw-bold text-dark fs-3">Carrera</label>
                <label className="fs-3">{userInfoFromDataBase.course !== ""? userInfoFromDataBase.course:"Tecnicatura ambiental"}</label>
              </span>

              <span className="d-flex flex-row gap-2">
                <label className="fw-bold text-dark fs-3">Legajo</label>
                <label className="fs-3">{userInfoFromDataBase.legajo !== ""? userInfoFromDataBase.legajo:"00/0001"}</label>
              </span>

              <span className="d-flex flex-row gap-2">
                <label className="fw-bold text-dark fs-3">Ingreso</label>
                <label className="fs-3">{userInfoFromDataBase.year !== ""? userInfoFromDataBase.year:"1801"}</label>
              </span>

              <span className="d-flex flex-row gap-2">
                <label className="fw-bold text-dark fs-3">Materias aprobadas:</label>
                <label className="fs-3">{userInfoFromDataBase.success !== ""? userInfoFromDataBase.success:"00"}</label>
              </span>

          </div>
          </div>
          }

          

          {mood===1 &&
          <div className="d-flex flex-row flex-wrap py-5 px-3">

          <div className="d-flex flex-column align-items-center gap-3 col-12">

                <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <label className="fw-bold text-dark fs-3">Nombre:</label>
                  <input value={userInfoFromDataBase.name} 
                    onChange={e => setUserInfo({...userInfoFromDataBase,name:e.target.value})} 
                    className="form-control form-control-lg" placeholder='Diego' maxLength="15"
                  />
                  {userInfoFromDataBase.name.length===15 && <p>No hay más espacio</p>}
                  {userInfoFromDataBase.name.length<3 && <p>No dejes vacio este campo</p>}
                </span>

                <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <label className="fw-bold text-dark fs-3">Apellido:</label>
                  <input value={userInfoFromDataBase.lastName} maxLength="15"
                    onChange={e => setUserInfo({...userInfoFromDataBase,lastName:e.target.value})} 
                    className="form-control form-control-lg" placeholder='Rodriguez'/>
                  {userInfoFromDataBase.lastName.length<3 && <p>No dejes vacio este campo</p>}
                  {userInfoFromDataBase.lastName.length===15 && <p>No hay más espacio</p>}
                </span>

                <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <label className="fw-bold text-dark fs-3">Correo:</label>
                  <input value={userInfoFromDataBase.email} onChange={e => setUserInfo({...userInfoFromDataBase,email:e.target.value})} className="form-control form-control-lg" placeholder='ejemplo@email.com'/>
                </span>

                <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <label className="fw-bold text-dark fs-3">DNI:</label>
                  <input value={userInfoFromDataBase.DNI} onChange={e => setUserInfo({...userInfoFromDataBase,DNI:e.target.value})} className="form-control form-control-lg" placeholder="00.000.000"/>
                  {userInfoFromDataBase.DNI.length<7 && <p>Ingresa un número valido</p>}
                </span>

                <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <label className="fw-bold text-dark fs-3">Celular:</label>
                  <input value={userInfoFromDataBase.phone} onChange={e => setUserInfo({...userInfoFromDataBase,phone:e.target.value})} className="form-control form-control-lg" placeholder="385-000-000"/>
                </span>

                <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                  <label className="fw-bold text-dark fs-3">Residencia:</label>
                  <input value={userInfoFromDataBase.address} onChange={e => setUserInfo({...userInfoFromDataBase,address:e.target.value})} className="form-control form-control-lg" placeholder="Capital"/>
                </span>

          </div>

          <div className="d-flex flex-column align-items-center gap-3 col-12 mt-3">

             <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                <label className="fw-bold text-dark fs-3">Carrera</label>
                <select class="form-select mb-3" aria-label=".form-select-lg example" defaultValue='default' onChange={e => setUserInfo({...userInfoFromDataBase,course:e.target.value})}>
                  <option value="default" disabled="disabled">Carrera</option>
                  <option value="Tec. Fitosanitarista">Tec. Fitosanitarista</option>
                  <option value="Tec. en Aserraderos">Tec. en Aserraderos</option>
                  <option value="Tec. en Viveros">Tec. en Viveros</option>
                  <option value="Ing. Forestal">Ing. Forestal</option>
                  <option value="Ing. en Industria Forestal">Ing. en Industria Forestal</option>
                  <option value="Lic. en Ecología y Conservación del Ambiente">Lic. en Ecología y Conservación del Ambiente</option>
                  <option value="Lic. en Enseñanzas de la Biología">Lic. en Enseñanzas de la Biología</option>
              </select>
             </span>



              <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                <label className="fw-bold text-dark fs-3">Legajo</label>
                <input value={userInfoFromDataBase.legajo} onChange={e => setUserInfo({...userInfoFromDataBase,legajo:e.target.value})} className="form-control form-control-lg" placeholder="00/2000"/>
              </span>

              <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                <label className="fw-bold text-dark fs-3">Ingreso</label>
                <input value={userInfoFromDataBase.year} onChange={e => setUserInfo({...userInfoFromDataBase,year:e.target.value})} className="form-control form-control-lg" placeholder="2005"/>
              </span>

              <span className="d-flex flex-column align-items-center justify-content-center gap-2">
                <label className="fw-bold text-dark fs-3">Materias aprobadas:</label>
                <input value={userInfoFromDataBase.success} onChange={e => setUserInfo({...userInfoFromDataBase,success:e.target.value})} className="form-control form-control-lg" placeholder="17"/>
              </span>

          </div>
          </div>
          }



          <div className="d-flex flex-row flex-wrap gap-2 align-items-around justify-content-center mb-3">

            {
             mood===0 && <button onClick={selectMood} className="yellowBtn col-10 col-md-6">Editar perfil</button>
            }
            {
              mood===1 && 
              userInfoFromDataBase.name.length>3 && 
              userInfoFromDataBase.lastName.length>3 &&
              userInfoFromDataBase.DNI.length>6 &&
             <button onClick={selectMood} className="yellowBtn col-10 col-md-6">Guardar</button>
            }
            {mood===1&& <button onClick={() => setMood(0)} className="brownBtn col-10 col-md-6">Volver</button>}
          </div>

        </div>




        <div>
          <div className="d-flex flex-column justify-content-center align-items-center mt-5">
              <h2 className="regularText militaryBackground text-white rounded-5 py-3 px-5">STATUS BIBLIOTECA</h2>
          </div>

          <div className="creamBackground rounded-5 m-2 px-2 py-4 text-center">
             <label className="fw-bold text-dark fs-3">Libros prestados</label>
            {
              userInfoFromDataBase.books?

              <div className="d-flex flex-column gap-2">
              {userInfoFromDataBase.books.map( (item,i) => {
                  const itemDate=dateHanddler(item.date)
                  return (
                  <span key={i} className='rounded-3 bg-white d-flex flex-row p-2'>
                  <label className="fw-bold col-9">{item.name}</label>
                  <label className={getLabelClass(itemDate)}>{itemDate==="suspendido"? "suspendido": `${itemDate} días` }</label>
                </span>
                )
                      
              })
              }

             </div>
             :
             <div className="d-flex flex-column align-items-center justify-content-center">
              <div class="spinner-grow text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
             </div>

            }
          </div>

          <div className="text-center mt-5">
                <label className="fw-bold text-dark fs-3">Estado:</label>
                {userInfoFromDataBase.status===true ?
                <p className="rounded-3 p-2 bg-success text-white fw-bold">Activo</p>
                :
                <p className="rounded-3 p-2 bg-danger text-white fw-bold">Suspendido</p>
                }
          </div>

          <p className='py-3'>Recuerda que los libros deben ser devueltos o renovados luego de 15 días. Para extender, o cambiar tu estado asiste a la biblioteca del CeFCF.</p>


        </div>


        <div>
          <div className="d-flex flex-column justify-content-center align-items-center mt-5">
              <h2 className="regularText militaryBackground text-white rounded-5 py-3 px-5">BECA APUNTE</h2>
          </div>

              <div className="d-flex flex-row flex-wrap justify-content-center align-items-center gap-3 mt-2">
                  <div className="card border-0 col-5 creamBackground" >
                  
                    <div className="card-body text-center">
                      <h2>{userInfoFromDataBase.prints ? userInfoFromDataBase.prints.black:"0"}</h2>
                      <p className="card-text">copias b/n</p>
                    </div>
                  </div>
                  <div className="card border-0 col-5 creamBackground" >
                    
                    <div className="card-body text-center">
                      <h2>{userInfoFromDataBase.prints ? userInfoFromDataBase.prints.color:"0"}</h2>
                      <p className="card-text">copias a color</p>
                    </div>
                  </div>
              </div>
          
        </div>



        <div>
          <div className="d-flex flex-column justify-content-center align-items-center mt-5">
              <h2 className="regularText militaryBackground text-white rounded-5 py-3 px-5">MONEDERO</h2>
          </div>

          <div className="creamBackground rounded-3 m-2 px-2 py-4 text-center">
              <span className='d-flex flex-row'>
                <label className='col-4 fw-bold'>Saldo:</label>
                <label className='col-8'>{userInfoFromDataBase.cash ? `${userInfoFromDataBase.cash} pb`:"0.00pb"}</label>
              </span>
          </div>
          <p className='text-center'>pf=peso forestal</p>
        </div>



    </div>
  )
}

export default UserCard